import React, {Fragment, useEffect, useRef, useState} from 'react';
import {Box, Button, CircularProgress, Container, Grid, Paper, TextareaAutosize, Typography} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import useStyles from "../../styles/styles";
import useFormInputs from "../../hooks/useFormInputs";
import theme from "../../styles/theme";

const SsnListHashArea = ({hashSsnQuery, hashSsnQueryLoading}) => {
    const classes = useStyles();
    const [errors, setErrors] = useState([]);
    const [ssns, setSsns] = useState([]);
    const textAreaRef = useRef(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const onSubmit = () => {
        setSubmitLoading(true);
        setErrors([]);
        let ssnList = ssns.split('\n');

        triggerCreate(ssnList);
    };

    const triggerCreate = async (ssnList) => {
        const promise = await hashSsnQuery({
            variables: {
                input: {
                    ssnList: ssnList
                }
            }
        })
    }

    const {handleSubmit} = useFormInputs(onSubmit);

    const getErrorsDuplicates = (duplicates) => {
        let seen = {}
        return duplicates.filter(() => {
            return seen.hasOwnProperty(duplicates.address) ? false : (seen[duplicates.address] = true)
        })
    }

    useEffect(() => {

        triggerList();
        //Set Height Match Height
        // setHeight(textAreaRef.current.clientHeight);

    }, [ssns]);

    useEffect(() => {
        if (!hashSsnQueryLoading) {
            setSubmitLoading(false)
        }

    }, [hashSsnQueryLoading]);

    const triggerList = () => {
        const arr = ssns.includes('\n') ? ssns.split('\n') : [ssns];
        let errors = checkErrors(arr);

        setErrors(errors);
    };

    /**
     * Checks for duplicates from what is entered
     * @param arr
     * @returns Object
     */
    const checkErrors = (arr) => {
        let address = []
        arr.forEach((x) => {
            const minLength = 9
            const maxLength = 9
            if (x.length >= minLength && x.length <= maxLength) {
                let isValid = true

                let isDuplicate = arr.filter(item => item === x).length > 1

                let errorMessage = null
                if (isDuplicate) {
                    errorMessage = `${x} is a duplicate entry`
                    address.push({
                        address: x,
                        errorMessage: errorMessage
                    });
                }

                if (!isValid) {
                    errorMessage = `${x} is not a valid ssn`
                    address.push({
                        address: x,
                        errorMessage: errorMessage
                    });
                }

            } else {
                const errorMessage = `${x} is not a valid ssn. Does not meet length requirements. Length is ${x.length}`
                address.push({
                    address: x,
                    errorMessage: errorMessage
                });
            }
        })

        return address
    };

    return (
        <Container maxWidth={false}>
            <Paper className={classes.paper} style={{marginBottom: 0, overflow: 'hidden'}}>
                <Typography variant="h5" align="center" gutterBottom>
                    Please enter SSNs to be hashed, separated by a new line.
                </Typography>
                <>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="body1">
                                <Box display="flex" flexDirection="row" alignItems="center">
                                    <strong>SSNs</strong>
                                </Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <TextareaAutosize
                                ref={textAreaRef}
                                style={{width: '100%', height: '320px', overflow: 'scroll'}}
                                value={ssns}
                                onChange={(e) => {
                                    setSsns(e.target.value);
                                }}
                                defaultValue={''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Box style={{
                                padding: '1px 8px 0',
                                height: '300px',
                                overflowY: 'scroll',
                                overflowX: 'hidden'
                            }}>
                                {errors.length ? (
                                    <Grid container spacing={2}>
                                        <>
                                            {errors.map((matchItem, idx) => {
                                                const {errorMessage} = matchItem;
                                                return (
                                                    <Fragment key={idx.toString()}>
                                                        <Grid
                                                            item
                                                            xs={5}
                                                            style={{
                                                                marginBottom: '10px',
                                                                borderBottom: '1px solid #dbdbdb',
                                                                marginLeft: theme.spacing(1),
                                                                marginRight: theme.spacing(1),
                                                                padding: theme.spacing(1),
                                                            }}
                                                        >
                                                            {errorMessage ? (
                                                                <Alert severity="error">
                                                                    {errorMessage}
                                                                </Alert>
                                                            ) : null}
                                                        </Grid>
                                                    </Fragment>
                                                )
                                            })}
                                        </>
                                    </Grid>
                                ) : null}
                            </Box>
                        </Grid>
                    </Grid>
                </>
                <Box
                    display={"flex"}
                    alignItems={"center"}
                    style={{margin: '10px 0'}}
                    justifyContent={"center"}>
                    <Box style={{marginRight: '10px'}}>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={submitLoading || !ssns.length || errors.length}
                            onClick={() => {
                                handleSubmit();
                            }}
                        >
                            {submitLoading ? (
                                <CircularProgress color="inherit"/>
                            ) : (
                                <>
                                    Submit
                                </>
                            )}
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Container>
    )

};

export default SsnListHashArea;
